/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import request, { ContentType, RequestParams } from './httpClient'
import { DomainSourceRecordListResp, GetAdminSourceRecordListParams, WebResp } from './types'

/**
 * @description 来源记录列表
 *
 * @tags AdminSourceRecordV1
 * @name GetAdminSourceRecordList
 * @summary 来源记录列表
 * @request GET:/api/v1/admin/source-records
 * @response `200` `(WebResp & {
    data?: DomainSourceRecordListResp,

})` OK
 */

export const getAdminSourceRecordList = (query: GetAdminSourceRecordListParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainSourceRecordListResp
    }
  >({
    path: `/api/v1/admin/source-records`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })
